export const formatNumber = (number) => {
  return (number).toLocaleString(
    'en-US',
    {
      minimumFractionDigits: 2,
      maximumFractionDigits:2
    }
  );
}
